import React, { useState, useContext } from 'react';
import { FormContext } from '../../FormContext';
import axios from 'axios'
import './FileUpload.css'
import { isFieldSigned } from './utils.js';

import InputAddRemove from './InputAddRemove';
const FileUpload = ({ field_filename, field_multiple_primary, field_column, field_label, field_id, field_value, field_disabled, field_mandatory, field_multiple, field_disabled_approver, field_multiple_id, field_multiple_type }) => {
  const { handleChangeInput, submitId, id, handleAddField, formStatus, handleRemoveLastField, formPageType, formApprovalIndex, formUserLock, formChatPerson, formOfficers, formMultipleType } = useContext(FormContext);

  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [uploadSuccess, setUploadedSuccess] = useState(false);
  const [tmpFile, setTmpFile] = useState(null)
  //console.log('tmpFile,', tmpFile)
  const path = (submitId && !tmpFile) ? `https://eform.hsu.edu.hk/file.php?id=form/${id}/${submitId}/${field_value}` : `https://eform.hsu.edu.hk/file.php?id=temporary/${tmpFile}`;
  //console.log('path', path)
  console.log('field_multiple_id in file upload', field_multiple_id)
  console.log('field_id in file upload', field_id)
  // let isSigned = field_id.startsWith("sign_");
  let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);

  const removeFile = e => {
    handleChangeInput(field_id, e, '')

    setUploadedSuccess(false)

  }


  const onSubmit = async e => {

    e.preventDefault();
    const formData = new FormData();
    // alert(JSON.stringify(e.target.files[0]))
    formData.append('file', e.target.files[0]);
    try {
      const res = await axios.post('https://eform.hsu.edu.hk/api/public/uploadTemp/index.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        // onUploadProgress: progressEvent => {
        //     setUploadPercentage(parseInt(Math.round((progressEvent.loaded * 100) / (progressEvent.total))))

        //     setTimeout(
        //         () => setUploadPercentage(0)
        //         , 5000);
        // }
        //Clear percentage

      })
      const { data } = res;
      //console.log('data', data)
      //console.log('e outside;m', e)
      // handleChangeInput(e)
      if (data !== 0) {
        setUploadedSuccess(true)
        setTmpFile(data)
        //console.log('e', e)
        handleChangeInput(field_id, e, data)


      } else {
        setUploadedSuccess(false)
        alert('File upload error')
      }


    } catch (error) {
      //console.log(error)
      setUploadedSuccess(false)
      alert('There is an error in uploading the file')

    }
  }
  //if uploaded file, show preview and remove file button
  // const renderUpload = (uploadSuccess || field_value) ? ((field_disabled) ? <div  ><a target="_blank" type="button"  className="text-success" onClick={() => window.open(path, "_blank")}>{field_filename?<span><span className="file-label">File: {field_filename} &nbsp;</span> <u>Download</u></span>:<u>Download</u>}</a></div> : (<div id="span_attachment_preview_1" ><a target="_blank" type="button" id="attachment_preview_1" className="text-success" onClick={() => window.open(path, "_blank")}>{field_filename?<span><span className="file-label">File: {field_filename} &nbsp;</span> <u>Download</u></span>:<u>Download </u>}</a> {formPageType !== 'user' && <a className="text-danger pl-3" id="remove_1" type="button" onClick={e => removeFile(e)}><u>Remove</u></a>}</div>)) : (
  //     <>
  //         <input disabled={ field_disabled}
  //             type="file" className="form-control form-input"  name="field_value" autoComplete="off" 
  //             accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf,.zip"

  //             style={{ height: 'calc(2.75rem)' }} onChange={onSubmit} />
  //         <input type="hidden" className="form-control form-input"  />
  //         <div className='mt-3 text-right'>
  //         {(field_multiple_primary=="yes" )&&<u className="text-success mr-3" onClick={()=>handleAddField(field_id)} style={{ cursor: 'pointer' }}>Add</u>}
  //         {(field_multiple_primary=="yes" )&&<u className="text-danger" onClick={()=>handleRemoveLastField(field_id)} style={{ cursor: 'pointer' }}>Remove</u>}
  //         </div>
  //     </>
  // )
  // return (
  //     <div className={`form-group ${field_column? field_column:'col-sm-12'}`}>
  //         <label htmlFor="password">{field_label} <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font></label>
  //         {renderUpload}
  //     </div>

  // )

  // const isDisabled = (formUserLock && formPageType== 'user') ? true:formPageType === 'user'
  // ? (field_multiple_id === "mapprover"
  //   ? isSigned||(field_id.startsWith('user_approver_') || field_id.startsWith('user_action_')) && parseInt(field_id.slice(-1)) < formApprovalIndex
  //   : true)
  // : field_disabled_approver === '1' || field_disabled || isSigned || (formStatus === 'Submitted' && (field_multiple_id === 'mapprover' || field_id.startsWith('user_approver_')));

  // let isDisabled =
  // formUserLock && formPageType === 'user'
  //   ? true
  //   : formPageType === 'user'
  //   ? field_multiple_id === 'mapprover'
  //     ? isSigned ||
  //       (field_id.startsWith('user_approver_') ||
  //         field_id.startsWith('user_action_')) &&
  //         parseInt(field_id.slice(-1)) < formApprovalIndex
  //     : true
  //   : field_disabled_approver === '1' ||
  //     field_disabled ||
  //     isSigned ||
  //     (formStatus === 'Submitted' &&
  //       (field_multiple_id === 'mapprover' ||
  //         field_id.startsWith('user_approver_')));
  let isDisabled;
  if (formUserLock && formPageType === 'user') {
    isDisabled = true;
  } else if (formPageType === 'user') {
    if (field_multiple_id === 'mapprover') {
      isDisabled = true || (
        (field_id.startsWith('user_approver_') ||
          field_id.startsWith('user_action_')) &&
        parseInt(field_id.slice(-1)) < formApprovalIndex);
    } else {
      isDisabled = true;
    }
  } else {
    isDisabled =
      field_disabled_approver === '1' ||
      field_disabled ||
      isSigned ||
      (formStatus === 'Submitted' &&
        (field_multiple_id === 'mapprover' ||
          field_id.startsWith('user_approver_')));
  }

  const renderUpload = (uploadSuccess || field_value) ? ((isDisabled) ? (
    <div>
      <span className="file-label">File: {field_filename}&nbsp;&nbsp;</span>
      <a target="_blank" type="button" className="text-success" onClick={() => window.open(path, "_blank")}>
        {field_filename ? (
          <span>
            <u>Download</u>
          </span>
        ) : (
          <u>Download</u>
        )}
      </a>
    </div>
  ) : (
    <div id="span_attachment_preview_1">
      <span className="file-label">File: {field_filename}&nbsp;&nbsp;</span>
      <a target="_blank" type="button" id="attachment_preview_1" className="text-success" onClick={() => window.open(path, "_blank")}>
        {field_filename ? (
          <span>
            <u>Download</u>
          </span>
        ) : (
          <u>Download</u>
        )}
      </a>
      {formPageType !== 'user' && (
        <a className="text-danger pl-3" id="remove_1" type="button" onClick={e => removeFile(e)}>
          <u>Remove</u>
        </a>
      )}
    </div>
  )) : (
    <>
      <input
        disabled={isDisabled}
        type="file"
        className="form-control form-input"
        name="field_value"
        autoComplete="off"
        accept=".xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip"
        style={{ height: 'calc(2.75rem)' }}
        onChange={onSubmit}
      />
      <input type="hidden" className="form-control form-input" />

      {/* {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id}/>} */}

      {/* {!formUserLock&&<div className="mt-3 text-right">
            {field_multiple_primary === 'yes' && (
              <u className="text-success mr-3" onClick={() => handleAddField(field_id)} style={{ cursor: 'pointer' }}>
                Add
              </u>
            )}
            {field_multiple_primary === 'yes' && (
              <u className="text-danger" onClick={() => handleRemoveLastField(field_id)} style={{ cursor: 'pointer' }}>
                Remove
              </u>
            )}
          </div>} */}

      {/* {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} field_multiple_type={field_multiple_type} />} */}

      {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} />}
      {/* <DummyComponent/> */}
    </>
  );

  return (
    <div className={`form-group ${field_column ? field_column : 'col-sm-12'}`}>
      <label htmlFor="password">
        {field_label} <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font>
      </label>
      {renderUpload}

    </div>
  );
}

export default FileUpload

